import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            input: {
                pilot: 'update'
            },
            click: {
                close: "close"
            }
        }
    }

    init() {
        // Events
        // ==========================================================================
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close();
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    /**
     * Init sprite data
     *
     * @param
     */
    initVisualizer(rows, columns) {
        this.NB_COLS = parseInt(columns)
        this.NB_ROWS = parseInt(rows)
        this.NB_FRAMES = this.NB_COLS * this.NB_ROWS

        this.FRAME_WIDTH = 100/(this.NB_COLS-1);
        this.FRAME_HEIGHT = 100/(this.NB_ROWS-1 || 1);

        this.getFrameValues()

        gsap.set(this.$('image')[0], { backgroundSize: `${100*this.NB_COLS}% ${100*this.NB_ROWS}%` });

        this.goToFrame(Math.round(this.NB_FRAMES/2))
    }

    /**
     * Set positions data
     *
     * @param
     */
    getFrameValues() {
        this.frames = [];
        for (let i = 0; i < this.NB_FRAMES; i++) {
            let column = i % this.NB_COLS;
            let row = Math.floor(i / this.NB_COLS);

            let frame = { column, row, x: (column * this.FRAME_WIDTH)+'%', y: (row * this.FRAME_HEIGHT)+'%' }
            this.frames.push(frame);
        }
    }

    /**
     * Go to frame
     *
     * @param
     */
    goToFrame(index) {
        gsap.set(this.$('image')[0], { backgroundPosition: `${this.frames[index].x} ${this.frames[index].y}` });
    }

    /**
     * Update
     *
     * @param
     */
    update(e) {
        let progress = parseInt(Math.round(e.curTarget.value * (this.NB_FRAMES - 1) / 100))
        this.goToFrame(progress)
    }

    /**
     * Open
     *
     * @param
     */
    open(data) {
        this.el.classList.add('is-active')
        this.el.classList.add('is-loading')
        this.$('pilot')[0].value = 50

        let imageSrc = data.img

        if(imageSrc.length) {
            let image = new Image();

            image.onload = () => {
                setTimeout(() => {
                    this.$('image')[0].style.backgroundImage = `url('${image.src}')`;

                    this.initVisualizer(data.rows, data.columns)

                    this.el.classList.remove('is-loading')
                }, 250);
            }

            image.src = imageSrc;
        }
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.el.classList.remove('is-active')
    }

    destroy() {
        document.removeEventListener('keyup', this.closeBind)
    }
}
